<ng-container *ngIf="keys?.length">
    <div>
        <mat-form-field class="multi-select-dropdown">
            <mat-label *ngIf="label">{{label}}</mat-label>
            <mat-select [formControl]="control" multiple>
                <ng-container *ngIf="selectAll">
                    <div matRipple (click)="onClickSelectAll()" class="multi-select-pseudo-checkbox">
                        <mat-pseudo-checkbox [state]="control.value?.length == keys.length ? 'checked' : 'unchecked'">
                        </mat-pseudo-checkbox>
                        <span [ngClass]="{'multi-select-pseudo-checkbox-select-all-checked': control.value?.length == keys.length}">Select All</span>
                    </div>
                    <div class="multi-select-separator"></div>
                </ng-container>
                <ng-container *ngIf="allOther">
                    <mat-option [value]="'ALL_OTHER'">
                        ALL OTHER
                    </mat-option>
                    <div class="multi-select-separator"></div>
                </ng-container>
                <mat-option *ngFor="let key of keys" [value]="key">
                    {{ options.get(key) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <ng-container *ngIf="chips">
        <div class="multi-select-chip-list" *ngIf="control.value && control.value.length < 25">
            <div class="multi-select-chip" *ngFor="let key of control.value">
                <button type="button" (click)="onClickRemove(key)">
                    <i class="fas fa-times"></i>
                </button>
                <div>{{ allOther && key == 'ALL_OTHER' ? 'ALL OTHER' : options.get(key) }}</div>
            </div>
        </div>
    </ng-container>
</ng-container>